import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// Autres modules externes utilises 

// Modules communs utilises
import { BootstrapPopupModule } from '../../../shared/bootstrap-popup/bootstrap-popup.module';
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { DragDropGroupsModule } from '../../../shared/drag-drop-groups/drag-drop-groups.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';
import { MatPaginatorIntlFr } from '../../../shared/pagination/paginator-intl-fr';
import { PannelModule } from '../../../shared/pannel/pannel.module';

// Modules meties utilises
import { ParcModule } from '../parc/parc.module';

// Composants metiers
import { EditGroupementDialogComponent } from './components/edit-groupement-dialog.component';
import { GestionGroupementsParcsComponent } from './components/gestion-groupements-parcs.component';
import { GroupementFilterableSelectorComponent } from './components/groupement-filterable-selector.component';

// Services metier
import { GroupementParcService } from './services/groupement-parc.service';
import { GroupementService } from './services/groupement.service';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatPaginatorModule,
		MatProgressBarModule,
		MatSortModule,
		MatTableModule,

		BootstrapPopupModule,
		CheckboxListModule,
		DragDropGroupsModule,
		FilterableSelectModule,
		PannelModule,
		
		ParcModule,
	],
	providers: [
		GroupementParcService,
		GroupementService,
		{
			// Configuration pour que les paginators affichent des libelles en francais
			provide: MatPaginatorIntl,
			useClass: MatPaginatorIntlFr
		},
	],
	declarations: [
		EditGroupementDialogComponent,
		GestionGroupementsParcsComponent,
		GroupementFilterableSelectorComponent,
	],
	exports: [
		EditGroupementDialogComponent,
		GestionGroupementsParcsComponent,
		GroupementFilterableSelectorComponent,
	]
})
export class GroupementParcModule {
	constructor() { }
}